export enum NdsChipState {
  DEFAULT = 'default',
  WARNING = 'warning',
  SECONDARY = 'secondary',
  DANGER = 'danger',
  NEUTRAL = 'neutral',
  SUCCESS = 'success',
}
